import { GOOGLE_APPOINTMENTS_CONVERSTION_PARAM } from "./constants";

export const getGoogleAppointmentsToken = (queryString: string) => {
  const token = new URLSearchParams(queryString).get(
    GOOGLE_APPOINTMENTS_CONVERSTION_PARAM
  );

  return token;
};
